// Libs
import { useFormContext } from 'react-hook-form';

// RDS
import Button from '@ramsey-design-system/button';
import { ArrowLeftIcon, ArrowRightIcon } from '@ramsey-design-system/icons';

// Hooks
import { STEPS, useWorkshopStepContext } from './WorkshopStepContext';

function WorkshopStepNavigation({
  disableNextStep = false,
  isSubmitting = false
}: {
  disableNextStep?: boolean;
  isSubmitting?: boolean;
}) {
  const { helpers, currentStep, isEditMode } = useWorkshopStepContext();
  const { formState, reset } = useFormContext();

  const isFirstStep = currentStep === STEPS.DETAILS;
  const isSummaryStep = currentStep === STEPS.SUMMARY;

  const handlePreviousStep = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    helpers.goToPrevStep();
  };

  const handleNextStep = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    helpers.goToNextStep();
  };

  const onCancel = () => {
    helpers.setStep(STEPS.SUMMARY);

    reset();
  };

  if (isEditMode) {
    return isSummaryStep ? null : (
      <div className="gap-md flex flex-col-reverse sm:flex-row sm:justify-end">
        <Button
          type="button"
          appearance="dangerSubtle"
          onClick={onCancel}
          disabled={isSubmitting}
          fullWidthOnMobile
          data-testid="workshop-edit-cancel-button"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          fullWidthOnMobile
          disabled={!formState.isDirty}
          loading={isSubmitting}
          data-testid="workshop-edit-save-button"
        >
          Save Changes
        </Button>
      </div>
    );
  }

  return (
    <div className="gap-lg mt-4 flex flex-col justify-between sm:flex-row">
      <Button
        appearance="ghost"
        size="large"
        type="button"
        fullWidthOnMobile
        icon={ArrowLeftIcon}
        disabled={isFirstStep}
        data-testid="workshop-previous-button"
        onClick={handlePreviousStep}
      >
        Previous
      </Button>

      {isSummaryStep ? (
        <Button
          type="submit"
          size="large"
          fullWidthOnMobile
          loading={isSubmitting}
          data-testid="workshop-create-button"
        >
          Create My Workshop
        </Button>
      ) : (
        <Button
          type="button"
          size="large"
          fullWidthOnMobile
          icon={ArrowRightIcon}
          disabled={disableNextStep}
          data-testid="workshop-next-button"
          onClick={handleNextStep}
        >
          Next
        </Button>
      )}
    </div>
  );
}

export default WorkshopStepNavigation;
